import React, { useState } from 'react';
import axios from 'axios';
import { apiBaseUrl } from '../../config/runtime';
import './ReportManager.css';

const ReportManager = () => {
  const [tipo, setTipo] = useState('tickets');
  const [inicio, setInicio] = useState('');
  const [fim, setFim] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleDownload = async (format) => {
    setLoading(true);
    setError('');
    try {
      const params = { type: tipo, format };
      if (inicio && fim) {
        params.inicio = inicio;
        params.fim = fim;
      }
      const response = await axios.get(`${apiBaseUrl}/reports`, {
        params,
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const ext = format === 'xlsx' ? 'xlsx' : format;
      link.setAttribute('download', `report_${tipo}.${ext}`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (err) {
      setError('Falha ao gerar relatório.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="report-manager">
      <div className="report-header">
        <div>
          <h2>Relatórios</h2>
          <p>Exporte dados em Excel ou XML para auditoria e gestão.</p>
        </div>
        <div className="report-actions">
          <button onClick={() => handleDownload('xlsx')} disabled={loading}>Exportar Excel</button>
          <button className="ghost" onClick={() => handleDownload('xml')} disabled={loading}>Exportar XML</button>
          <button className="ghost" onClick={() => handleDownload('csv')} disabled={loading}>Exportar CSV</button>
        </div>
      </div>

      {error && <p className="error-message">{error}</p>}

      <div className="report-card">
        <div className="report-field">
          <label>Tipo de relatório</label>
          <select value={tipo} onChange={(e) => setTipo(e.target.value)}>
            <option value="tickets">Tickets</option>
            <option value="customers">Clientes</option>
            <option value="messages">Mensagens</option>
          </select>
        </div>
        <div className="report-field">
          <label>Data início</label>
          <input type="date" value={inicio} onChange={(e) => setInicio(e.target.value)} />
        </div>
        <div className="report-field">
          <label>Data fim</label>
          <input type="date" value={fim} onChange={(e) => setFim(e.target.value)} />
        </div>
      </div>
    </div>
  );
};

export default ReportManager;
